import { render } from "./Creations.vue?vue&type=template&id=1905373e"
import script from "./Creations.vue?vue&type=script&lang=js"
export * from "./Creations.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\gjf1611\\code\\private\\planet-c\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__